import { render, staticRenderFns } from "./table-head.vue?vue&type=template&id=34120590&"
import script from "./table-head.vue?vue&type=script&lang=js&"
export * from "./table-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34120590')) {
      api.createRecord('34120590', component.options)
    } else {
      api.reload('34120590', component.options)
    }
    module.hot.accept("./table-head.vue?vue&type=template&id=34120590&", function () {
      api.rerender('34120590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/table-head.vue"
export default component.exports